import { KeyValue } from "@/main/models/common";
import { RateImportStatusActionTypes, RateImportStatusTypes } from "./rateImportStatusTypes";

export function getRateImportStatus(): RateImportStatusActionTypes {
	return {
		type: RateImportStatusTypes.GET_RATE_IMPORT_STATUS,
	};
}

export function saveRateImportStatus(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): RateImportStatusActionTypes {
	return {
		type: RateImportStatusTypes.SAVE_RATE_IMPORT_STATUS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerRateImportStatus(): RateImportStatusActionTypes {
	return {
		type: RateImportStatusTypes.RESET_REDUCER_RATE_IMPORT_STATUS,
	};
}
